// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Col} from '../../col/Col'

export enum FilterItemType {
    BOTH = 'both',
    SIMPLE = 'simple',
    EXTENDED = 'extended'
}

// Components
@Component({
    name: 'FilterItem',
    components: {
        Col
    },
    mixins: [
        template,
    ]
})
export class FilterItem extends Vue {

    @Prop({default: 'simple'})
    public type!: string

    @Prop({default: 4})
    public cols!: number
}